import type { IAdTarget } from './types';

/**
 * Make contents of an html element empty
 * @param element
 */
export const emptyTheContentsOfAnElement = (element: HTMLElement) => {
  while (element.lastChild) {
    element.removeChild(element.lastChild);
  }
};

/**
 * Get the GPT number of the ad target
 * @param target
 * @returns
 */
export const getTheGPTNumberOfTheAdTarget = (target: string) => {
  const id: RegExpExecArray | null = /\d+/g.exec(target);
  const gptNumber: string | undefined = id && id[0] ? id[0] || '' : undefined;
  return gptNumber;
};

/**
 * Insert a div in the page by applying an insertion strategy
 * @param target
 * @param index
 * @param insert
 * @param insertLocation
 * @param windowContext
 * @returns
 */
export const applyDivInsertionStrategy = (
  target: string,
  index: string,
  insert: IAdTarget['insert'],
  insertLocation: HTMLElement,
  windowContext: Window = window
) => {
  const adDiv = windowContext.document.createElement('div');
  adDiv.id = target.concat(index);
  switch (insert) {
    case 'after':
      insertLocation.insertAdjacentElement('afterend', adDiv);
      break;
    case 'before':
      insertLocation.insertAdjacentElement('beforebegin', adDiv);
      break;
    case 'prependInside':
      insertLocation.insertAdjacentElement('afterbegin', adDiv);
      break;
    default:
      insertLocation.appendChild(adDiv);
  }

  return adDiv;
};

/**
 * Check keywords and decide if the target string has at least one of the passed keywords
 * @param target
 * @param keywords
 * @returns If any keyword is contained in the target or not
 */
export const containsKeyword = (target: string | string[], keywords: string[]): boolean => {
  for (const word of keywords) {
    if (target.includes(word)) {
      return true;
    }
  }
  return false;
};

/**
 * Check if any path regex matches the current pathname
 * @param regexes
 * @param windowContext
 */
export const matchesPath = (regexes: string[], windowContext: Window = window): boolean => {
  for (let i = 0; i < regexes.length; i++) {
    const pathRegex = new RegExp(regexes[i]);
    if (pathRegex.test(windowContext.location.pathname)) {
      return true;
    }
  }
  return false;
};

/**
 * Finds the suitable GPT slot for a given advertisement ID
 * @param id
 * @param windowContext
 * @returns GPT slot
 */
export const findSlotById = (id: string, windowContext: Window & typeof globalThis = window) => {
  return windowContext.googletag
    .pubads()
    .getSlots()
    .find((slot: { getSlotElementId: () => string }) => slot.getSlotElementId() === id);
};
